var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_2166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.35938 5C6.32587 5 7.10938 4.2165 7.10938 3.25C7.10938 2.2835 6.32587 1.5 5.35938 1.5C4.39288 1.5 3.60938 2.2835 3.60938 3.25C3.60938 4.2165 4.39288 5 5.35938 5Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76172 1.75C9.26992 2.05623 9.60982 2.61343 9.60982 3.25C9.60982 3.88657 9.26992 4.44377 8.76172 4.75",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60938 10.2V10.5H9.10938V10.2C9.10938 9.0799 9.10938 8.51985 8.8914 8.09202C8.69965 7.7157 8.39368 7.40973 8.01735 7.21798C7.58953 7 7.02948 7 5.90938 7H4.80937C3.68927 7 3.12923 7 2.7014 7.21798C2.32507 7.40973 2.01911 7.7157 1.82736 8.09202C1.60938 8.51985 1.60938 9.0799 1.60938 10.2Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6096 10.4998V10.1998C11.6096 9.07967 11.6096 8.51962 11.3916 8.0918C11.1999 7.71547 10.8939 7.40952 10.5176 7.21777",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_2166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.609375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d56e86fd5025dac2fc2cb138ca833a24.svg";
export { ForwardRef as ReactComponent };